/**
 * Application-related types for consistent usage across BFF services
 */

export enum ApplicationName {
    CMD = 'CMD',
    SALES_CHECKIN = 'Sales Checkin',
    OPEN_DEAL = 'Open Deal',
    CHOOSE_VEHICLE = 'Choose Vehicle'
}
